import React, { useState } from "react";
import "../css/payments.css";

function Payment_excel() {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState("");

  // Helper function for authenticated requests
  const authFetch = async (url, options = {}) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      ...options.headers
    };
    return fetch(url, { ...options, headers: { ...headers, Authorization: `Bearer ${token}` } });
  };

  const handleDownload = async () => {
    setDownloading(true);
    setError("");

    try {
      const token = localStorage.getItem("access_token");
      if (!token) {
        setError("No authentication token found. Please log in again.");
        setDownloading(false);
        return;
      }

      const response = await authFetch("/api/admin/student_payments/excel");

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Failed to download Excel file");
      }

      // Get the filename from Content-Disposition header or use default
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = 'payments.csv';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '');
        }
      }

      // Convert response to blob
      const blob = await response.blob();
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error("Error downloading Excel file:", error);
      setError(error.message || "Failed to download Excel file");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="payment-excel-container" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <div className="header-section" style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '20px',
        background: 'white',
        padding: '24px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
      }}>
        <h1 style={{ margin: 0, color: '#1a2634', fontSize: '28px' }}>Payment Excel Export</h1>
        <button
          onClick={handleDownload}
          disabled={downloading}
          style={{
            backgroundColor: downloading ? '#6c757d' : '#28a745',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: downloading ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'all 0.2s',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
          onMouseEnter={(e) => {
            if (!downloading) {
              e.target.style.backgroundColor = '#218838';
            }
          }}
          onMouseLeave={(e) => {
            if (!downloading) {
              e.target.style.backgroundColor = '#28a745';
            }
          }}
        >
          {downloading ? (
            <>
              <span className="loading-spinner-small" style={{ 
                display: 'inline',
                flex: '0 0 auto',
                content: 'center',
                width: '16px',
                height: '16px',
                border: '2px solid rgba(255,255,255,0.3)',
                borderRadius: '50%',
                borderTopColor: 'white',
                animation: 'spin 0.8s linear infinite'
              }}></span>
              Downloading...
            </>
          ) : (
            <>
              <span style={{ fontSize: '18px' }}></span>
              Download Excel File
            </>
          )}
        </button>
      </div>

      {error && (
        <div className="error-message" style={{
          flex: '1',
          content: 'center',
          backgroundColor: '#f8d7da',
          color: '#721c24',
          padding: '16px 20px',
          borderRadius: '8px',
          marginBottom: '20px',
          border: '1px solid #f5c6cb'
        }}>
          <strong>Error:</strong> {error}
        </div>
      )}


      {/* Add keyframe animation for spinner */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default Payment_excel;